import Translations from '@/i18n/us_en/translations'

const Internationalization = {
    install(Vue, options) {
        Vue.prototype.$i18n = function (key, fallback = undefined) {
            let translation = Translations[key];

            if (translation) {
                return translation;
            }

            if (fallback) {
                return fallback;
            }

            return key;
        }
    }
};

export default Internationalization;
